<label [ngClass]="getClass()">
    <input type="checkbox"
    [id]="'fc-compare-' + item.product.id"
    [(ngModel)]="item.compare"
    (change)="onCompareItem($event, item)"
    [disabled]="isDisabled()">
    Compare
</label>